export type DevicePlatform = 'ios' | 'android' | 'other';

export function getDevicePlatform(userAgent: string): DevicePlatform {
	// @nuxtjs/device skips platform flags when Cloudflare supplies cf-device-type.
	if (/ipad|iphone|ipod/i.test(userAgent)) {
		return 'ios';
	}
	if (/android/i.test(userAgent)) {
		return 'android';
	}

	return 'other';
}
